import API from "@core/api/api";

export const getAllPackagesNoReturnVoucher = async () => {
  const response = await API.get(`/packages/filter/noReturnVoucher`);
  return response.data;
};

export const createReturnVoucher = async (returnVoucherData) => {
  const response = await API.post(`/return-vouchers`, returnVoucherData);
  return response.data;
};

export const fetchReturnVouchers = async () => {
  const response = await API.get(`/return-vouchers`);
  return response.data;
};

export const fetchReturnVoucherById = async (id) => {
  const response = await API.get(`/return-vouchers/${id}`);
  return response.data;
};

export const generateReturnVoucherPDF = async (returnVoucherId) => {
  const response = await API.post(`/return-vouchers/${returnVoucherId}/pdf`);
  return response.data;
};
